import { useQuery } from '@tanstack/react-query';
import {DbPathHelper, Http} from "../../services";

export const useDynamicFields = () => {
    const fetchDynamicFields = async () => {
        const {data} = await Http.get(
            DbPathHelper.getLetterTemplateDynamicFields(),
            {'Content-type': 'multipart/form-data'},
        );

        if (!data) {
            throw new Error('Network response was not ok');
        }

        return data.data;
    };

    return useQuery({
        queryKey: ['dynamicFields'],
        queryFn: fetchDynamicFields,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        retry: 2,
    });
};
